import * as Adflow from 'adflow';
import { APIClientContext as FigmaAPIClientContext } from '@adflow/figma';
import { APIClientContext as SelectAdvertiserAPIClientContext } from '@adflow/marketing-cloud';
import { APIClientContext as ShadowBrandAPIClientContext } from '@adflow/shadow-brand';
import { APIClientContext as CreatomateAPIContextProvider } from '@adflow/creatomate';
import { Datasources, EditorState } from '@adflow/types';
import { TRPCClient } from '../utils/apiClient';
import { useEditorModules } from '../utils/hooks/useEditorModules';
import { loadAdvertiserFonts } from '../webmcp/loadAdvertiserFonts';
import TemplateBuilderOperationAuditProvider from '../operationAudit/TemplateBuilderOperationAuditProvider';
import { withTemplateSaveMetadata } from '../save/withTemplateSaveMetadata';
import TemplateWebMCPHost from '../webmcp/TemplateWebMCPHost';
import TemplateBuilderPreview from '../components/TemplateBuilderPreview';
import { gql } from '@apollo/client';
import apolloClient from '../../apolloClient';
import { useMemo } from 'react';

const UPSERT_TEMPLATE_MUTATION = gql`
  mutation UpsertTemplate($data: JSON!) {
    upsertTemplate(data: $data) {
      id
    }
  }
`;

function Create() {
  const { modules } = useEditorModules();

  const dataSources = useMemo(() => Datasources.createDataSourceDefinitions(null), []);

  const renderPreview = (args: Adflow.RenderPreviewArgs) => <TemplateBuilderPreview {...args} />;

  const onSave = async (editorState: EditorState) => {
    await apolloClient.mutate({
      mutation: UPSERT_TEMPLATE_MUTATION,
      variables: {
        data: withTemplateSaveMetadata({
          name: editorState.name,
          brandId: editorState.brand?._id || null,
          brandKitId: editorState.brandKitId || null,
          dataSources: editorState.dataSources,
          adElements: editorState.elements,
          displayOptions: editorState.displayOptions,
          thumbnail: editorState.thumbnailURL,
          businessEntityId: editorState.businessEntityId,
          importSourceJSON: editorState.importSourceJSON,
          importSourceType: editorState.importSourceType,
          videoProjectId: editorState.videoProjectId,
          animation: editorState.animation,
          bgColour: editorState.bgColour,
        }),
      },
    });
  };
  return (
    <div className="editor-page">
      <Adflow.EditorProvider dataSources={dataSources}>
        <TemplateBuilderOperationAuditProvider>
          <FigmaAPIClientContext.Provider {...TRPCClient.figmaClient}>
            <CreatomateAPIContextProvider.Provider {...TRPCClient.creatomateClient}>
              <ShadowBrandAPIClientContext.Provider {...TRPCClient.consoleClient}>
                <SelectAdvertiserAPIClientContext.Provider {...TRPCClient.marketingCloudClient}>
                  <TemplateWebMCPHost
                    templateId="new"
                    editorReady
                    hasEditPermissions
                    routeMode="create"
                    listAdvertisers={TRPCClient.marketingCloudClient.listAdvertisers}
                    loadAdvertiserFonts={loadAdvertiserFonts}
                  />
                  <Adflow.Editor
                    onSave={onSave}
                    modules={modules}
                    renderPreview={renderPreview}
                  ></Adflow.Editor>
                </SelectAdvertiserAPIClientContext.Provider>
              </ShadowBrandAPIClientContext.Provider>
            </CreatomateAPIContextProvider.Provider>
          </FigmaAPIClientContext.Provider>
        </TemplateBuilderOperationAuditProvider>
      </Adflow.EditorProvider>
    </div>
  );
}

export default Create;
